import { Box, Tab, Tabs, MenuItem, MenuList } from "@mui/material"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { setActiveTab } from "../../redux/reducer/appReducer"
import { INVOICE, PATIENTINFO, REGISTER, SCHEDULE } from "../../utils/constants"
import { useNavigate } from "react-router-dom"
import { GetUserInfo } from "../GlobalComponents/CommonComponents"

function TabsMenu({ isMobile }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { activeTab, canShowAll } = GetUserInfo()

  function handleTabChange(event, newValue) {
    // console.log("newValue", newValue)
    dispatch(setActiveTab(newValue))
    if (activeTab === newValue) {
      window.location.reload()
    } else {
      navigate(`/${newValue}`)
    }
  }

  const tabs = [
    { label: "Patient Info", value: PATIENTINFO },
    { label: "Schedule", value: SCHEDULE },
    { label: "Invoice", value: INVOICE },
  ]

  if (canShowAll) {
    tabs.push({ label: "Register", value: REGISTER })
  }

  return (
    <Box sx={{ display: isMobile ? "block" : "flex", justifyContent: "flex-end" }}>
      {!isMobile && (
        <Tabs
          value={activeTab}
          // onChange={handleTabChange}
          aria-label="form sections"
        >
          {tabs.map((tab, index) => (
            <Tab 
              key={index} 
              label={tab.label} 
              value={tab.value}
              onClick={() => handleTabChange(null, tab.value)}
            />
          ))}
        </Tabs>
      )}
      {isMobile &&
        tabs.map((tab, index) => (
          <MenuItem
            key={index}
            onClick={(event) => handleTabChange(event, tab.value)}
          >
            {tab.label}
          </MenuItem>
        ))}
    </Box>
  )
}

export default TabsMenu
